import { render } from "./team-member-demographic-data.vue?vue&type=template&id=0acd6e64&scoped=true&ts=true"
import script from "./team-member-demographic-data.vue?vue&type=script&lang=ts"
export * from "./team-member-demographic-data.vue?vue&type=script&lang=ts"

import "./team-member-demographic-data.vue?vue&type=style&index=0&id=0acd6e64&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0acd6e64"]])

export default __exports__